(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.announcement__slide')];
      if (this.slides.length < 2) return;
      this.index = 0;
      this.interval = Number(this.dataset.interval) || 5000;
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      this.start();
    }
    disconnectedCallback() { this.stop(); }
    go() {
      const prev = this.slides[this.index];
      this.index = (this.index + 1) % this.slides.length;
      const next = this.slides[this.index];
      prev.classList.remove('is-active');
      prev.setAttribute('aria-hidden', 'true');
      next.classList.add('is-active');
      next.removeAttribute('aria-hidden');
    }
    start() {
      if (this.dataset.autoplay === 'false' || this.timer) return;
      this.timer = setInterval(() => this.go(), this.interval);
    }
    stop() { clearInterval(this.timer); this.timer = null; }
  }
  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      if (this.__init) return; this.__init = 1;
      this.overlay = this.querySelector('.cd__overlay');
      this.addEventListener('click', (e) => {
        var closeEl = e.target.closest('[data-cd-close]');
        if (closeEl) { this.close(); return; }
        var chg = e.target.closest('[data-cd-change]');
        if (chg) { e.preventDefault(); this.change(chg.getAttribute('data-cd-change'), chg.getAttribute('data-cd-qty'), chg); }
      });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.classList.contains('is-open')) this.close(); });

      // Ícone do carrinho no header abre a gaveta
      document.querySelectorAll('.mdhdr__cart').forEach((a) => {
        a.addEventListener('click', (e) => { e.preventDefault(); this.open(); });
      });

      window.MatchdayCart = this;
      this.animateProgress();
      this.initTimer();
    }
    initTimer() {
      var mins = parseInt(this.getAttribute('data-timer-min'), 10) || 5;
      this.timerMs = mins * 60000;
      var end = 0;
      try { end = parseInt(localStorage.getItem('md_cart_timer_end'), 10); } catch (e) {}
      var now = Date.now();
      if (!end || end < now) { end = now + this.timerMs; try { localStorage.setItem('md_cart_timer_end', end); } catch (e) {} }
      this.timerEnd = end;
      this.updateTimer();
      var self = this;
      if (this.__timerInt) clearInterval(this.__timerInt);
      this.__timerInt = setInterval(function () { self.updateTimer(); }, 1000);
    }
    updateTimer() {
      var rem = this.timerEnd - Date.now();
      if (rem <= 0) { this.timerEnd = Date.now() + this.timerMs; try { localStorage.setItem('md_cart_timer_end', this.timerEnd); } catch (e) {} rem = this.timerMs; }
      var el = this.querySelector('[data-cd-timer]');
      if (!el) return;
      var m = Math.floor(rem / 60000), s = Math.floor((rem % 60000) / 1000);
      el.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    }
    animateProgress() {
      var fill = this.querySelector('.cd__prog-fill');
      if (!fill) { this.__progPct = 0; return; }
      var target = parseFloat(fill.getAttribute('data-pct')) || 0;
      var prev = this.__progPct || 0;
      fill.style.width = prev + '%';
      var self = this;
      requestAnimationFrame(function () { requestAnimationFrame(function () { fill.style.width = target + '%'; }); });
      this.__progPct = target;
    }
    open() {
      this.style.display = 'block';
      requestAnimationFrame(() => { this.classList.add('is-open'); });
      document.documentElement.style.overflow = 'hidden';
    }
    close() {
      this.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      var self = this; setTimeout(function () { if (!self.classList.contains('is-open')) self.style.display = 'none'; }, 520);
    }
    lockBtn(btn, on) { if (btn) btn.disabled = on; }

    async refresh() {
      try {
        const res = await fetch(window.location.pathname + '?sections=cart-drawer');
        const data = await res.json();
        const html = data['cart-drawer'];
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-cd-inner]');
        const cur = this.querySelector('[data-cd-inner]');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        this.syncCount(doc);
        this.animateProgress();
        this.updateTimer();
      } catch (e) {}
    }
    syncCount(doc) {
      // atualiza o badge do header
      var el = doc ? doc.querySelector('cart-drawer') : this;
      var count = el ? el.getAttribute('data-count') : null;
      var badge = document.querySelector('.mdhdr__cart-count');
      var cartLink = document.querySelector('.mdhdr__cart');
      if (count && +count > 0) {
        if (badge) badge.textContent = count;
        else if (cartLink) { var s = document.createElement('span'); s.className = 'mdhdr__cart-count'; s.textContent = count; cartLink.appendChild(s); }
      } else if (badge) { badge.remove(); }
    }

    async change(key, qty, btn) {
      this.lockBtn(btn, true);
      try {
        await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: parseInt(qty, 10) })
        });
        await this.refresh();
      } catch (e) { this.lockBtn(btn, false); }
    }

    async addAndOpen(items) {
      try {
        await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });
        await this.refresh();
        this.open();
        return true;
      } catch (e) { return false; }
    }
  }
  customElements.define('cart-drawer', CartDrawer);

  /* Mexico — RFC/CURP obrigatorio no carrinho */
  (function () {
    if (window.__mdRfcInit) return; window.__mdRfcInit = 1;
    var RE = [
      /^[A-ZÑ&]{4}[0-9]{6}[A-Z0-9]{3}$/,
      /^[A-ZÑ&]{3}[0-9]{6}[A-Z0-9]{3}$/,
      /^[A-Z]{4}[0-9]{6}[HM][A-Z]{5}[A-Z0-9][0-9]$/
    ];
    function clean(v) { return (v || '').toUpperCase().replace(/[^A-ZÑ&0-9]/g, '').slice(0, 18); }
    function valid(v) { for (var i = 0; i < RE.length; i++) { if (RE[i].test(v)) return true; } return false; }
    function field() { return document.querySelector('[data-cd-rfc-input]'); }
    function setErr(on) {
      var box = document.querySelector('[data-cd-rfc-error]'); var inp = field();
      if (inp) { if (on) inp.classList.add('is-invalid'); else inp.classList.remove('is-invalid'); }
      if (box) box.hidden = !on;
    }
    function save(v) {
      try {
        return fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { RFC: v } })
        });
      } catch (e) { return Promise.resolve(); }
    }
    document.addEventListener('input', function (e) {
      var inp = e.target && e.target.closest ? e.target.closest('[data-cd-rfc-input]') : null; if (!inp) return;
      var pos = inp.selectionStart; var before = inp.value; var after = clean(before);
      if (before !== after) { inp.value = after; try { inp.setSelectionRange(pos, pos); } catch (_) {} }
      if (valid(after)) setErr(false);
    });
    document.addEventListener('blur', function (e) {
      var inp = e.target && e.target.closest ? e.target.closest('[data-cd-rfc-input]') : null; if (!inp) return;
      save(clean(inp.value));
    }, true);
    document.addEventListener('submit', function (e) {
      var form = e.target && e.target.closest ? e.target.closest('.cd__checkout-form') : null; if (!form) return;
      var inp = field(); if (!inp) return;
      var v = clean(inp.value);
      if (!valid(v)) { e.preventDefault(); setErr(true); inp.focus(); return; }
      inp.value = v; setErr(false);
      var hidden = form.querySelector('input[name="attributes[RFC]"]');
      if (!hidden) { hidden = document.createElement('input'); hidden.type = 'hidden'; hidden.name = 'attributes[RFC]'; form.appendChild(hidden); }
      hidden.value = v;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cj-gallery"] && !Shopify.designMode) return;
  try {
    
  /* Mesmo helper de arrastar declarado em cj-offer.liquid — guarda idempotente pra
     que qualquer uma das duas seções possa sumir sem quebrar a outra. */
  window.cjDragScroll =
    window.cjDragScroll ||
    function (track) {
      if (!track || track.dataset.cjDrag) return;
      track.dataset.cjDrag = '1';
      let down = false;
      let moved = false;
      let startX = 0;
      let startLeft = 0;
      track.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'touch') return;
        down = true;
        moved = false;
        startX = e.clientX;
        startLeft = track.scrollLeft;
        track.classList.add('is-dragging');
      });
      track.addEventListener(
        'pointermove',
        (e) => {
          if (!down) return;
          const dx = e.clientX - startX;
          if (Math.abs(dx) > 3) moved = true;
          track.scrollLeft = startLeft - dx;
          e.preventDefault();
        },
        { passive: false }
      );
      const end = () => {
        if (!down) return;
        down = false;
        track.classList.remove('is-dragging');
      };
      ['pointerup', 'pointercancel', 'pointerleave'].forEach((ev) => track.addEventListener(ev, end));
      track.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
      track.addEventListener('dragstart', (e) => e.preventDefault());
    };

  (function () {
    function setup(root) {
      const track = root.querySelector('.prodcar__track');
      if (!track) return;
      window.cjDragScroll(track);

      const dotsEl = root.querySelector('[data-cjg-dots]');
      if (!dotsEl) return;
      const cells = [...track.querySelectorAll('.prodcar__cell')];

      const build = () => {
        // nada pra arrastar => bolinha nenhuma (senão promete rolagem que não existe)
        const scrollable = track.scrollWidth > track.clientWidth + 4;
        dotsEl.style.display = scrollable && cells.length > 1 ? '' : 'none';
        if (dotsEl.children.length === cells.length) return;
        dotsEl.innerHTML = '';
        cells.forEach((cell, i) => {
          const d = document.createElement('button');
          d.type = 'button';
          d.className = 'prodcar__dot' + (i === 0 ? ' is-active' : '');
          d.setAttribute('aria-label', String(i + 1));
          d.addEventListener('click', () => {
            track.scrollTo({ left: cell.offsetLeft - track.offsetLeft, behavior: 'smooth' });
          });
          dotsEl.appendChild(d);
        });
      };

      const sync = () => {
        if (!dotsEl.children.length) return;
        const left = track.scrollLeft;
        let best = 0;
        let bestDist = Infinity;
        cells.forEach((cell, i) => {
          const dist = Math.abs(cell.offsetLeft - track.offsetLeft - left);
          if (dist < bestDist) { bestDist = dist; best = i; }
        });
        [...dotsEl.children].forEach((d, i) => d.classList.toggle('is-active', i === best));
      };

      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', build);
      build();
    }

    function boot() {
      document.querySelectorAll('.cjg').forEach(setup);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cj-kit"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.cjkReady) return;
      root.dataset.cjkReady = '1';

      var total = parseInt(root.dataset.slots, 10) || 3;
      var slots = new Array(total).fill(null);   // {variantId, size, title, img}
      var target = 0;
      var pending = null;

      var drawer = root.querySelector('[data-cjk-drawer]');
      var stepShirt = root.querySelector('[data-cjk-step-shirt]');
      var stepSize = root.querySelector('[data-cjk-step-size]');
      var foot = root.querySelector('[data-cjk-foot]');
      var backBtn = root.querySelector('[data-cjk-back]');
      var panelTitle = root.querySelector('[data-cjk-panel-title]');
      var sizesEl = root.querySelector('[data-cjk-sizes]');
      var confirmBtn = root.querySelector('[data-cjk-confirm]');
      var addBtn = root.querySelector('[data-cjk-add]');
      var progressEl = root.querySelector('[data-cjk-progress]');
      var slotEls = [].slice.call(root.querySelectorAll('[data-cjk-slot]'));

      function openDrawer() {
        drawer.hidden = false;
        requestAnimationFrame(function () { drawer.classList.add('is-open'); });
        document.documentElement.style.overflow = 'hidden';
      }
      function closeDrawer() {
        drawer.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        setTimeout(function () { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 520);
      }

      function showShirtStep() {
        stepShirt.hidden = false;
        stepSize.hidden = true;
        foot.hidden = true;
        backBtn.hidden = true;
        if (panelTitle) panelTitle.textContent = root.dataset.pickTitle || '';
      }
      function showSizeStep() {
        stepShirt.hidden = true;
        stepSize.hidden = false;
        foot.hidden = false;
        backBtn.hidden = false;
        if (panelTitle) panelTitle.textContent = root.dataset.sizeTitle || '';
      }

      function render() {
        var done = slots.filter(Boolean).length;

        slotEls.forEach(function (el, i) {
          var item = slots[i];
          var img = el.querySelector('[data-cjk-slot-img]');
          var label = el.querySelector('[data-cjk-slot-label]');
          var clear = el.querySelector('[data-cjk-clear]');
          el.classList.toggle('is-filled', !!item);
          if (item) {
            img.src = item.img; img.alt = item.title; img.hidden = false;
            label.textContent = item.title + ' · ' + item.size;
            clear.hidden = false;
          } else {
            img.removeAttribute('src'); img.hidden = true;
            label.textContent = root.dataset.slotEmpty || '';
            clear.hidden = true;
          }
        });

        if (progressEl) {
          progressEl.innerHTML = done >= total
            ? (root.dataset.ready || '')
            : (root.dataset.progress || '').replace('{done}', '<b>' + done + '</b>').replace('{total}', total);
        }
        if (addBtn) addBtn.disabled = done < total;
      }

      // abrir a gaveta numa vaga
      root.querySelectorAll('[data-cjk-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          target = parseInt(btn.dataset.cjkOpen, 10);
          pending = null;
          showShirtStep();
          openDrawer();
        });
      });

      // limpar vaga (não pode abrir a gaveta junto)
      root.querySelectorAll('[data-cjk-clear]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          slots[parseInt(btn.dataset.cjkClear, 10)] = null;
          render();
        });
      });

      // passo 1 -> passo 2
      root.querySelectorAll('[data-cjk-shirt]').forEach(function (opt) {
        opt.addEventListener('click', function () {
          var variants = [];
          try { variants = JSON.parse(opt.querySelector('[data-cjk-variants]').textContent); } catch (e) { return; }

          pending = { title: opt.dataset.title, img: opt.dataset.img, variantId: null, size: null };

          var img = root.querySelector('[data-cjk-d-img]');
          var nameEl = root.querySelector('[data-cjk-d-name]');
          var priceEl = root.querySelector('[data-cjk-d-price]');
          if (img) { img.src = opt.dataset.img; img.alt = opt.dataset.title; }
          if (nameEl) nameEl.textContent = opt.dataset.title;
          if (priceEl) priceEl.textContent = opt.dataset.price;

          sizesEl.innerHTML = '';
          variants.forEach(function (v) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'cjk__size';
            b.textContent = v.title;
            b.disabled = !v.available;
            b.addEventListener('click', function () {
              sizesEl.querySelectorAll('.cjk__size').forEach(function (o) { o.classList.remove('is-active'); });
              b.classList.add('is-active');
              pending.variantId = v.id;
              pending.size = v.title;
              confirmBtn.disabled = false;
            });
            sizesEl.appendChild(b);
          });

          confirmBtn.disabled = true;
          showSizeStep();
        });
      });

      backBtn.addEventListener('click', showShirtStep);
      var backFoot = root.querySelector('[data-cjk-back-foot]');
      if (backFoot) backFoot.addEventListener('click', showShirtStep);
      root.querySelectorAll('[data-cjk-close]').forEach(function (el) { el.addEventListener('click', closeDrawer); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
      });

      confirmBtn.addEventListener('click', function () {
        if (!pending || !pending.variantId) return;
        slots[target] = pending;
        pending = null;
        render();
        closeDrawer();
        // ainda falta vaga? abre a próxima assim que a gaveta termina de fechar
        var next = slots.indexOf(null);
        if (next > -1) {
          setTimeout(function () {
            target = next;
            showShirtStep();
            openDrawer();
          }, 560);
        }
      });

      // kit inteiro pro carrinho
      addBtn.addEventListener('click', async function () {
        var chosen = slots.filter(Boolean);
        if (chosen.length < total) return;
        var byVariant = {};
        chosen.forEach(function (i) { byVariant[i.variantId] = (byVariant[i.variantId] || 0) + 1; });
        var items = Object.keys(byVariant).map(function (id) {
          return { id: parseInt(id, 10), quantity: byVariant[id] };
        });

        addBtn.disabled = true;
        var base = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
        var cart = document.querySelector('cart-drawer');
        var ok = false;
        if (cart && typeof cart.addAndOpen === 'function') ok = await cart.addAndOpen(items);
        if (!ok) {
          try {
            await fetch(base + 'cart/add.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: items })
            });
            window.location.href = base + 'cart';
            return;
          } catch (e) {}
        }
        slots = new Array(total).fill(null);
        render();
      });

      render();
    }

    function boot() { document.querySelectorAll('[data-cjk]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cj-offer"] && !Shopify.designMode) return;
  try {
    
  /* Arrastar com o mouse num track que já rola sozinho (overflow-x: auto).
     No toque o scroll nativo é melhor (tem inércia), então só entramos no caminho
     do mouse. Definido com guarda porque cj-gallery.liquid declara o mesmo helper —
     assim qualquer uma das duas seções pode sumir sem quebrar a outra. */
  window.cjDragScroll =
    window.cjDragScroll ||
    function (track) {
      if (!track || track.dataset.cjDrag) return;
      track.dataset.cjDrag = '1';
      let down = false;
      let moved = false;
      let startX = 0;
      let startLeft = 0;
      track.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'touch') return;
        down = true;
        moved = false;
        startX = e.clientX;
        startLeft = track.scrollLeft;
        track.classList.add('is-dragging');
      });
      track.addEventListener(
        'pointermove',
        (e) => {
          if (!down) return;
          const dx = e.clientX - startX;
          if (Math.abs(dx) > 3) moved = true;
          track.scrollLeft = startLeft - dx;
          e.preventDefault();
        },
        { passive: false }
      );
      const end = () => {
        if (!down) return;
        down = false;
        track.classList.remove('is-dragging');
      };
      ['pointerup', 'pointercancel', 'pointerleave'].forEach((ev) => track.addEventListener(ev, end));
      // não deixa o arrasto virar clique no link da foto
      track.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
      track.addEventListener('dragstart', (e) => e.preventDefault());
    };

  (function () {
    function init(root) {
      const track = root.querySelector('.pmbo__track');
      const dotsEl = root.querySelector('[data-cj-dots]');
      if (!track) return;
      window.cjDragScroll(track);

      root.querySelectorAll('.pmbo__arrow').forEach((btn) => {
        btn.addEventListener('click', () => {
          track.scrollBy({ left: (btn.dataset.dir === 'next' ? 1 : -1) * track.clientWidth, behavior: 'smooth' });
        });
      });

      const slides = track.querySelectorAll('.pmbo__slide');
      if (dotsEl) {
        slides.forEach((s, i) => {
          const d = document.createElement('button');
          d.type = 'button';
          d.className = 'pmbo__dot' + (i === 0 ? ' is-active' : '');
          d.setAttribute('aria-label', String(i + 1));
          d.addEventListener('click', () => track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }));
          dotsEl.appendChild(d);
        });
        track.addEventListener(
          'scroll',
          () => {
            const idx = Math.round(track.scrollLeft / track.clientWidth);
            dotsEl.querySelectorAll('.pmbo__dot').forEach((dot, i) => dot.classList.toggle('is-active', i === idx));
          },
          { passive: true }
        );
      }

      if (root.hasAttribute('data-autoplay') && slides.length > 1) {
        const speed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 4000;
        let timer = null;
        const advance = () => {
          let idx = Math.round(track.scrollLeft / track.clientWidth) + 1;
          if (idx >= slides.length) idx = 0;
          track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
        };
        const start = () => { if (!timer) timer = setInterval(advance, speed); };
        const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
        ['mouseenter', 'pointerdown', 'touchstart'].forEach((e) => root.addEventListener(e, stop, { passive: true }));
        ['mouseleave', 'pointerup', 'touchend'].forEach((e) => root.addEventListener(e, () => { stop(); start(); }, { passive: true }));
        start();
      }

      const code = root.querySelector('.cjo__code');
      if (code && navigator.clipboard) {
        code.addEventListener('click', async () => {
          try {
            await navigator.clipboard.writeText(code.dataset.cjCode);
          } catch (e) {
            return;
          }
          const original = code.textContent;
          code.textContent = code.dataset.cjCopied || original;
          code.classList.add('is-copied');
          setTimeout(() => {
            code.textContent = original;
            code.classList.remove('is-copied');
          }, 1600);
        });
      }
    }

    function boot() {
      document.querySelectorAll('[data-cj-offer]').forEach((el) => {
        if (el.dataset.cjReady) return;
        el.dataset.cjReady = '1';
        init(el);
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    // o editor da loja re-renderiza a seção sem recarregar a página
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-carousel"] && !Shopify.designMode) return;
  try {
    
  class CollectionCarousel extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('.colcar__tab')];
      this.panels = [...this.querySelectorAll('.colcar__panel')];
      this.active = 0;

      this.tabs.forEach((tab, i) => tab.addEventListener('click', () => this.activate(i)));

      this.panels.forEach((panel) => {
        const track = panel.querySelector('.colcar__track');
        if (!track) return;
        panel.querySelectorAll('.colcar__arrow').forEach((btn) => {
          btn.addEventListener('click', () => {
            const dir = btn.dataset.dir === 'next' ? 1 : -1;
            track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' });
          });
        });
        track.addEventListener('scroll', () => this.syncDots(panel), { passive: true });
      });

      window.addEventListener('resize', () => this.buildDots(this.panels[this.active]));
      if (this.panels[0]) this.buildDots(this.panels[0]);
    }

    activate(i) {
      this.active = i;
      this.tabs.forEach((t, idx) => t.classList.toggle('is-active', idx === i));
      this.panels.forEach((p, idx) => p.classList.toggle('is-active', idx === i));
      const panel = this.panels[i];
      const track = panel.querySelector('.colcar__track');
      if (track) track.scrollLeft = 0;
      this.buildDots(panel);
    }

    buildDots(panel) {
      if (!panel) return;
      const dotsEl = panel.querySelector('.colcar__dots');
      const track = panel.querySelector('.colcar__track');
      if (!track) return;
      const pages = Math.max(1, Math.ceil((track.scrollWidth - 4) / track.clientWidth));
      const single = pages <= 1;
      panel.querySelectorAll('.colcar__arrow').forEach((a) => { a.style.display = single ? 'none' : ''; });
      if (!dotsEl) return;
      dotsEl.innerHTML = '';
      if (single) { dotsEl.style.display = 'none'; return; }
      dotsEl.style.display = '';
      for (let p = 0; p < pages; p++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'colcar__dot' + (p === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Page ' + (p + 1));
        dot.addEventListener('click', () => track.scrollTo({ left: p * track.clientWidth, behavior: 'smooth' }));
        dotsEl.appendChild(dot);
      }
    }

    syncDots(panel) {
      const dotsEl = panel.querySelector('.colcar__dots');
      const track = panel.querySelector('.colcar__track');
      if (!dotsEl || !track) return;
      const dots = [...dotsEl.children];
      if (!dots.length) return;
      const page = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach((d, idx) => d.classList.toggle('is-active', idx === page));
    }
  }
  customElements.define('collection-carousel', CollectionCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class MobileNav extends HTMLElement {
    connectedCallback() {
      this.root = this.querySelector('.mnav__pane--root');
      this.toggle = document.getElementById(this.dataset.toggle);
      this.active = null;

      this.querySelectorAll('[data-drill]').forEach((btn) => {
        btn.addEventListener('click', () => this.drill(btn.dataset.drill));
      });
      this.querySelectorAll('[data-back]').forEach((btn) => {
        btn.addEventListener('click', () => this.back());
      });

      if (this.toggle) {
        this.toggle.addEventListener('change', () => {
          if (this.toggle.checked) {
            this.place();
          } else {
            this.back();
          }
        });
      }
      window.addEventListener('resize', () => {
        if (this.toggle && this.toggle.checked) this.place();
      });
    }

    place() {
      const header = this.closest('.mdhdr');
      if (header) {
        const bottom = header.getBoundingClientRect().bottom;
        this.style.setProperty('--mnav-top', Math.max(0, bottom) + 'px');
      }
    }

    drill(id) {
      const pane = this.querySelector('#' + CSS.escape(id));
      if (!pane) return;
      if (this.active) this.active.classList.remove('is-active');
      pane.classList.add('is-active');
      pane.scrollTop = 0;
      this.root.classList.add('is-behind');
      this.active = pane;
    }

    back() {
      if (this.active) {
        this.active.classList.remove('is-active');
        this.active = null;
      }
      if (this.root) this.root.classList.remove('is-behind');
    }
  }
  customElements.define('mobile-nav', MobileNav);

  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.panel = this.querySelector('.mdsearch__panel');
      this.results = this.querySelector('.mdsearch__results');
      if (!this.input || !this.panel) return;

      this.input.addEventListener('input', () => this.onInput());
      this.input.addEventListener('focus', () => {
        if (this.results.innerHTML.trim()) this.open();
      });
      document.addEventListener('click', (e) => {
        if (!this.contains(e.target)) this.close();
      });
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') { this.close(); this.input.blur(); }
      });
    }

    onInput() {
      const q = this.input.value.trim();
      clearTimeout(this.timer);
      if (q.length < 2) { this.results.innerHTML = ''; this.close(); return; }
      this.timer = setTimeout(() => this.search(q), 220);
    }

    async search(q) {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const url = root + 'search/suggest'
        + '?q=' + encodeURIComponent(q)
        + '&section_id=predictive-search'
        + '&resources[type]=product,collection'
        + '&resources[limit]=6'
        + '&resources[options][unavailable_products]=last'
        + '&resources[options][fields]=title,product_type,variants.title,vendor,tag';
      try {
        const res = await fetch(url, { signal: this.controller.signal });
        const text = await res.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const inner = doc.querySelector('.mdsearch__inner');
        this.results.innerHTML = inner ? inner.innerHTML : text;
        this.open();
      } catch (e) {
        /* fetch abortado — ignora */
      }
    }

    open() { this.panel.hidden = false; }
    close() { this.panel.hidden = true; }
  }
  customElements.define('predictive-search', PredictiveSearch);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  class HeroBanner extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.hero__track');
      this.dots = [...this.querySelectorAll('.hero__dot')];
      this.count = this.track ? this.track.children.length : 0;
      this.interval = Number(this.dataset.interval) || 6000;
      if (this.count < 2) return;

      // Clones nas pontas para loop infinito de verdade
      const firstReal = this.track.children[0];
      const lastReal = this.track.children[this.count - 1];
      const firstClone = firstReal.cloneNode(true);
      const lastClone = lastReal.cloneNode(true);
      [firstClone, lastClone].forEach((c) => {
        c.classList.add('is-clone');
        c.setAttribute('aria-hidden', 'true');
      });
      this.track.appendChild(firstClone);
      this.track.insertBefore(lastClone, firstReal);

      this.real = 0;   // banner real ativo (0..count-1)
      this.pos = 1;    // posição no track (0 = clone do último; 1..count = reais; count+1 = clone do primeiro)
      this.animating = false;
      this.place(false); // posiciona sem animar (evita flash do clone)

      this.querySelectorAll('[data-dir]').forEach((btn) => {
        btn.addEventListener('click', () => { this.go(btn.dataset.dir === 'next' ? 1 : -1); this.restart(); });
      });
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => { this.goto(Number(dot.dataset.goto)); this.restart(); });
      });

      this.track.addEventListener('transitionend', (e) => {
        if (e.target !== this.track || e.propertyName !== 'transform') return;
        this.animating = false;
        if (this.pos === this.count + 1) { this.pos = 1; this.place(false); }
        else if (this.pos === 0) { this.pos = this.count; this.place(false); }
      });

      // pausa no hover / foco
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());

      // swipe no touch
      let sx = 0, sy = 0, dx = 0, dy = 0, tracking = false;
      this.addEventListener('touchstart', (e) => {
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; dx = 0; dy = 0; tracking = true; this.stop();
      }, { passive: true });
      this.addEventListener('touchmove', (e) => {
        if (!tracking) return; dx = e.touches[0].clientX - sx; dy = e.touches[0].clientY - sy;
      }, { passive: true });
      this.addEventListener('touchend', () => {
        if (!tracking) return; tracking = false; this.start();
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          this.go(dx < 0 ? 1 : -1); this.restart();
          this.justDragged = true; setTimeout(() => { this.justDragged = false; }, 60);
        }
      });
      this.addEventListener('click', (e) => {
        if (this.justDragged) { e.preventDefault(); e.stopPropagation(); }
      }, true);

      this.start();
    }
    disconnectedCallback() { this.stop(); }

    place(animate) {
      this.track.classList.toggle('is-animating', animate);
      this.track.style.transform = 'translateX(' + (-this.pos * 100) + '%)';
      // força reflow ao desanimar pra o snap ser instantâneo
      if (!animate) void this.track.offsetHeight;
    }

    go(step) {
      if (this.animating) return;
      this.animating = true;
      this.pos += step;
      this.real = (this.real + step + this.count) % this.count;
      this.place(true);
      this.updateDots();
    }

    goto(r) {
      if (this.animating || r === this.real) return;
      this.animating = true;
      this.pos = r + 1;
      this.real = r;
      this.place(true);
      this.updateDots();
    }

    updateDots() {
      this.dots.forEach((d, i) => d.classList.toggle('is-active', i === this.real));
    }

    start() {
      if (this.dataset.autoplay === 'false' || this.timer) return;
      this.timer = setInterval(() => this.go(1), this.interval);
    }
    stop() { clearInterval(this.timer); this.timer = null; }
    restart() { this.stop(); this.start(); }
  }
  customElements.define('hero-banner', HeroBanner);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  class ProductCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.prodcar__track');
      this.dotsEl = this.querySelector('.prodcar__dots');
      if (!this.track) return;
      this.querySelectorAll('.prodcar__arrow').forEach((btn) => {
        btn.addEventListener('click', () => {
          const dir = btn.dataset.dir === 'next' ? 1 : -1;
          this.track.scrollBy({ left: dir * this.track.clientWidth * 0.85, behavior: 'smooth' });
        });
      });
      this.track.addEventListener('scroll', () => this.syncDots(), { passive: true });
      window.addEventListener('resize', () => this.buildDots());
      this.buildDots();
    }
    buildDots() {
      const pages = Math.max(1, Math.ceil((this.track.scrollWidth - 4) / this.track.clientWidth));
      const single = pages <= 1;
      this.querySelectorAll('.prodcar__arrow').forEach((a) => { a.style.display = single ? 'none' : ''; });
      if (!this.dotsEl) return;
      this.dotsEl.innerHTML = '';
      if (single) { this.dotsEl.style.display = 'none'; return; }
      this.dotsEl.style.display = '';
      for (let p = 0; p < pages; p++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'prodcar__dot' + (p === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Page ' + (p + 1));
        dot.addEventListener('click', () => this.track.scrollTo({ left: p * this.track.clientWidth, behavior: 'smooth' }));
        this.dotsEl.appendChild(dot);
      }
    }
    syncDots() {
      if (!this.dotsEl) return;
      const dots = [...this.dotsEl.children];
      if (!dots.length) return;
      const page = Math.round(this.track.scrollLeft / this.track.clientWidth);
      dots.forEach((d, i) => d.classList.toggle('is-active', i === page));
    }
  }
  customElements.define('product-carousel', ProductCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  class ReviewsCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.rv__track');
      this.dotsEl = this.querySelector('.rv__dots');
      if (!this.track) return;
      this.querySelectorAll('.rv__arrow').forEach((btn) => {
        btn.addEventListener('click', () => {
          const dir = btn.dataset.dir === 'next' ? 1 : -1;
          this.track.scrollBy({ left: dir * this.track.clientWidth * 0.85, behavior: 'smooth' });
        });
      });
      this.track.addEventListener('scroll', () => this.syncDots(), { passive: true });
      window.addEventListener('resize', () => this.buildDots());
      this.buildDots();
    }
    buildDots() {
      const pages = Math.max(1, Math.ceil((this.track.scrollWidth - 4) / this.track.clientWidth));
      const single = pages <= 1;
      this.querySelectorAll('.rv__arrow').forEach((a) => { a.style.display = single ? 'none' : ''; });
      if (!this.dotsEl) return;
      this.dotsEl.innerHTML = '';
      if (single) { this.dotsEl.style.display = 'none'; return; }
      this.dotsEl.style.display = '';
      for (let p = 0; p < pages; p++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'rv__dot' + (p === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Page ' + (p + 1));
        dot.addEventListener('click', () => this.track.scrollTo({ left: p * this.track.clientWidth, behavior: 'smooth' }));
        this.dotsEl.appendChild(dot);
      }
    }
    syncDots() {
      if (!this.dotsEl) return;
      const dots = [...this.dotsEl.children];
      if (!dots.length) return;
      const page = Math.round(this.track.scrollLeft / this.track.clientWidth);
      dots.forEach((d, i) => d.classList.toggle('is-active', i === page));
    }
  }
  customElements.define('reviews-carousel', ReviewsCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-anatomy"] && !Shopify.designMode) return;
  try {
    
  class TlAnatomy extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.querySelectorAll('[data-view-btn]').forEach(function (btn) {
        btn.addEventListener('click', function () { self.show(btn.dataset.viewBtn); });
      });

      var pairs = this.querySelectorAll('[data-key]');
      pairs.forEach(function (el) {
        var key = el.dataset.key;
        var on = function () { self.highlight(key, true); };
        var off = function () { self.highlight(key, false); };
        el.addEventListener('mouseenter', on);
        el.addEventListener('mouseleave', off);
        el.addEventListener('focusin', on);
        el.addEventListener('focusout', off);
        el.addEventListener('click', function () {
          var already = el.classList.contains('is-on');
          self.clear();
          if (!already) self.highlight(key, true);
        });
      });
    }

    clear() {
      this.querySelectorAll('.is-on[data-key]').forEach(function (e) { e.classList.remove('is-on'); });
    }

    highlight(key, state) {
      this.querySelectorAll('[data-key="' + key + '"]').forEach(function (e) {
        e.classList.toggle('is-on', state);
      });
    }

    show(view) {
      this.clear();
      this.querySelectorAll('[data-view-btn]').forEach(function (b) {
        b.classList.toggle('is-on', b.dataset.viewBtn === view);
      });
      this.querySelectorAll('[data-view-img]').forEach(function (i) { i.hidden = i.dataset.viewImg !== view; });
      this.querySelectorAll('[data-view-spot]').forEach(function (s) { s.hidden = s.dataset.viewSpot !== view; });
      this.querySelectorAll('[data-view-note]').forEach(function (n) { n.hidden = n.dataset.viewNote !== view; });
    }
  }
  if (!customElements.get('tl-anatomy')) customElements.define('tl-anatomy', TlAnatomy);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-believe"] && !Shopify.designMode) return;
  try {
    
  class TlBelieve extends HTMLElement {
    connectedCallback() {
      var self = this;
      var btn = this.querySelector('[data-sign]');
      var hint = this.querySelector('[data-sign-hint]');
      if (btn) {
        btn.addEventListener('click', function () {
          var open = self.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (hint) hint.textContent = open ? (self.dataset.hintOpen || '') : (self.dataset.hintClosed || '');
        });
      }

      var coupon = this.querySelector('[data-coupon]');
      if (coupon) {
        var action = coupon.querySelector('[data-coupon-action]');
        var original = action ? action.textContent : '';
        coupon.addEventListener('click', function () {
          var code = coupon.getAttribute('data-coupon');
          try {
            if (navigator.clipboard && navigator.clipboard.writeText) {
              navigator.clipboard.writeText(code);
            } else {
              var t = document.createElement('textarea');
              t.value = code; t.style.position = 'fixed'; t.style.opacity = '0';
              document.body.appendChild(t); t.select(); document.execCommand('copy'); document.body.removeChild(t);
            }
          } catch (e) {}
          if (action) {
            action.textContent = coupon.getAttribute('data-copied') || 'Copied';
            setTimeout(function () { action.textContent = original; }, 1800);
          }
        });
      }
    }
  }
  if (!customElements.get('tl-believe')) customElements.define('tl-believe', TlBelieve);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-buy"] && !Shopify.designMode) return;
  try {
    
  class TlBuy extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.form = this.querySelector('.tl-buy__form');

      /* galeria */
      this.querySelectorAll('[data-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var i = btn.dataset.thumb;
          self.querySelectorAll('[data-main-img]').forEach(function (img) { img.hidden = img.dataset.mainImg !== i; });
          self.querySelectorAll('[data-thumb]').forEach(function (b) { b.classList.toggle('is-on', b === btn); });
        });
      });

      var out = this.querySelector('[data-size-out]');
      this.querySelectorAll('input[name="id"]').forEach(function (r) {
        r.addEventListener('change', function () { if (out) out.textContent = r.dataset.size; });
      });

      this.nameEl = this.querySelector('[data-perso-name]');
      this.numEl = this.querySelector('[data-perso-number]');
      if (this.nameEl) {
        this.nameEl.addEventListener('input', function () {
          this.value = this.value.toUpperCase().replace(/[^A-Z .'-]/g, '');
          self.syncPresets();
        });
      }
      if (this.numEl) {
        this.numEl.addEventListener('input', function () {
          this.value = this.value.replace(/[^0-9]/g, '');
          self.syncPresets();
        });
      }
      this.querySelectorAll('[data-preset]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (self.nameEl) self.nameEl.value = btn.dataset.name || '';
          if (self.numEl) self.numEl.value = btn.dataset.number || '';
          self.syncPresets();
        });
      });

      if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));
      var stickyAdd = this.querySelector('[data-sticky-add]');
      if (stickyAdd && this.form) {
        stickyAdd.addEventListener('click', function () {
          if (self.form.requestSubmit) self.form.requestSubmit();
          else self.form.querySelector('[data-atc]').click();
        });
      }

      var atc = this.querySelector('[data-atc]');
      var bar = this.querySelector('[data-sticky]');
      if (atc && bar && 'IntersectionObserver' in window) {
        this.atcVisible = false;
        new IntersectionObserver(function (entries) {
          self.atcVisible = entries[0].isIntersecting;
          self.toggleBar();
        }, { threshold: 0 }).observe(atc);
        window.addEventListener('scroll', function () { self.toggleBar(); }, { passive: true });
      }
    }

    toggleBar() {
      var bar = this.querySelector('[data-sticky]');
      if (!bar) return;
      bar.classList.toggle('is-on', window.scrollY > 420 && !this.atcVisible);
    }

    syncPresets() {
      var n = this.nameEl ? this.nameEl.value.trim() : '';
      var num = this.numEl ? this.numEl.value.trim() : '';
      this.querySelectorAll('[data-preset]').forEach(function (b) {
        var on = !!(b.dataset.name || b.dataset.number) && b.dataset.name === n && b.dataset.number === num;
        b.classList.toggle('is-on', on);
      });
    }

    onSubmit(e) {
      var form = this.form;
      var idInput = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');
      if (!idInput) return;

      /* propriedade vazia não vai pro carrinho */
      form.querySelectorAll('input[name^="properties["]').forEach(function (inp) {
        inp.disabled = inp.value.trim() === '';
      });

      if (!(window.MatchdayCart && window.MatchdayCart.addAndOpen)) return;
      e.preventDefault();

      var props = {};
      form.querySelectorAll('input[name^="properties["]').forEach(function (inp) {
        if (inp.disabled) return;
        var m = inp.name.match(/^properties\[(.+)\]$/);
        if (m) props[m[1]] = inp.value.trim();
      });

      var btn = form.querySelector('[data-atc]');
      var label = btn ? btn.querySelector('[data-atc-label]') : null;
      var orig = label ? label.textContent : '';
      if (btn) btn.disabled = true;
      if (label) label.textContent = label.getAttribute('data-adding') || 'Adding…';

      window.MatchdayCart.addAndOpen([{ id: parseInt(idInput.value, 10), quantity: 1, properties: props }]).then(function () {
        if (btn) btn.disabled = false;
        if (label) label.textContent = orig;
      });
    }
  }
  if (!customElements.get('tl-buy')) customElements.define('tl-buy', TlBuy);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-gallery"] && !Shopify.designMode) return;
  try {
    
  class TlSwipe extends HTMLElement {
    connectedCallback() {
      var track = this.querySelector('[data-track]');
      if (!track) return;
      var card = track.querySelector('.tl-card');
      this.querySelectorAll('[data-dir]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = card ? card.offsetWidth + 16 : track.clientWidth * 0.8;
          track.scrollBy({ left: btn.dataset.dir === 'next' ? step : -step, behavior: 'smooth' });
        });
      });
    }
  }
  if (!customElements.get('tl-swipe')) customElements.define('tl-swipe', TlSwipe);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-hero"] && !Shopify.designMode) return;
  try {
    
  class TlCountdown extends HTMLElement {
    connectedCallback() {
      var start = Date.parse(this.dataset.start);
      if (isNaN(start)) return;
      this.start = start;
      this.episodes = parseInt(this.dataset.episodes, 10) || 1;
      this.week = 7 * 24 * 60 * 60 * 1000;
      this.labelEl = this.querySelector('[data-count-label]');
      this.d = this.querySelector('[data-d]');
      this.h = this.querySelector('[data-h]');
      this.m = this.querySelector('[data-m]');
      this.tick();
      this.timer = setInterval(this.tick.bind(this), 30000);
    }
    disconnectedCallback() { clearInterval(this.timer); }

    /* Alvo = estreia, ou o próximo episódio semanal ainda por vir. */
    target(now) {
      for (var i = 0; i < this.episodes; i++) {
        var t = this.start + i * this.week;
        if (t > now) return { at: t, ep: i + 1 };
      }
      return null;
    }

    tick() {
      var now = Date.now();
      var next = this.target(now);
      if (!next) {
        this.classList.add('tl-count--done');
        if (this.labelEl) this.labelEl.textContent = this.dataset.labelAfter || '';
        clearInterval(this.timer);
        return;
      }
      var tpl = next.ep === 1 ? this.dataset.labelBefore : this.dataset.labelDuring;
      if (this.labelEl) this.labelEl.textContent = (tpl || '').replace('{ep}', next.ep);
      var diff = Math.max(0, next.at - now);
      var set = function (el, value, unit) {
        if (el) el.innerHTML = value + '<i>' + unit + '</i>';
      };
      set(this.d, Math.floor(diff / 86400000), this.dataset.unitD);
      set(this.h, Math.floor((diff % 86400000) / 3600000), this.dataset.unitH);
      set(this.m, Math.floor((diff % 3600000) / 60000), this.dataset.unitM);
    }
  }
  if (!customElements.get('tl-countdown')) customElements.define('tl-countdown', TlCountdown);

  /* Reveal on scroll — vale pra toda a landing (todas as seções tl-*). */
  (function () {
    if (window.__tlReveal) return;
    window.__tlReveal = true;
    if (!('IntersectionObserver' in window)) return;
    document.documentElement.setAttribute('data-tl-anim', '');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    var scan = function () {
      document.querySelectorAll('.tlp [data-reveal]:not(.is-in)').forEach(function (el) { io.observe(el); });
    };
    scan();
    document.addEventListener('shopify:section:load', scan);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-stories"] && !Shopify.designMode) return;
  try {
    
  class TlStories extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.frames = [].slice.call(this.querySelectorAll('[data-frame]'));
      this.bars = [].slice.call(this.querySelectorAll('[data-bar]'));
      if (!this.frames.length) return;
      this.i = 0;
      this.dur = (parseFloat(this.dataset.autoplay) || 5) * 1000;
      this.paused = true;

      this.querySelector('[data-prev]').addEventListener('click', function () { self.go(self.i - 1); });
      this.querySelector('[data-next]').addEventListener('click', function () { self.go(self.i + 1); });

      /* segurar pausa; arrastar troca de quadro */
      var sx = 0, sy = 0, moved = false, downAt = 0;
      this.addEventListener('pointerdown', function (e) {
        sx = e.clientX; sy = e.clientY; moved = false; downAt = Date.now();
        self.pause();
      });
      this.addEventListener('pointermove', function (e) {
        if (!downAt) return;
        if (Math.abs(e.clientX - sx) > 40 && Math.abs(e.clientX - sx) > Math.abs(e.clientY - sy)) moved = true;
      });
      var release = function (e) {
        if (!downAt) return;
        var dx = e.clientX - sx;
        if (moved) { self.go(dx < 0 ? self.i + 1 : self.i - 1); }
        downAt = 0;
        self.resume();
      };
      this.addEventListener('pointerup', release);
      this.addEventListener('pointercancel', function () { downAt = 0; self.resume(); });
      this.addEventListener('pointerleave', function () { downAt = 0; self.resume(); });

      /* só roda quando está na tela */
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries[0].isIntersecting ? self.resume() : self.pause();
        }, { threshold: 0.35 }).observe(this);
      } else {
        this.resume();
      }

      this.bars.forEach(function (bar, idx) {
        bar.addEventListener('click', function (e) { e.stopPropagation(); self.go(idx); });
        bar.querySelector('i').addEventListener('animationend', function () {
          if (idx === self.i) self.go(self.i + 1);
        });
      });
    }

    go(next) {
      var total = this.frames.length;
      this.i = ((next % total) + total) % total;
      var i = this.i;
      this.frames.forEach(function (f, idx) { f.classList.toggle('is-on', idx === i); });
      this.bars.forEach(function (b, idx) {
        b.classList.toggle('is-done', idx < i);
        b.classList.toggle('is-active', idx === i);
        /* reinicia a animação da barra ativa */
        var fill = b.querySelector('i');
        fill.style.animation = 'none';
        void fill.offsetWidth;
        fill.style.animation = '';
      });
      if (this.paused) this.setPlayState('paused');
    }

    setPlayState(state) {
      this.bars.forEach(function (b) {
        b.querySelector('i').style.animationPlayState = state;
      });
    }

    pause() {
      this.paused = true;
      this.setPlayState('paused');
    }

    resume() {
      this.paused = false;
      this.style.setProperty('--tl-dur', this.dur + 'ms');
      this.setPlayState('running');
    }
  }
  if (!customElements.get('tl-stories')) customElements.define('tl-stories', TlStories);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-story"] && !Shopify.designMode) return;
  try {
    
  class TlStory extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.steps = [].slice.call(this.querySelectorAll('[data-step]'));
      this.imgs = [].slice.call(this.querySelectorAll('[data-story-img]'));
      this.dot = this.querySelector('[data-story-dot]');
      if (!this.steps.length) return;

      this.activate(this.steps[0]);

      /* O passo que estiver no meio da tela manda na foto e no ponto. */
      this.io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) self.activate(entry.target);
        });
      }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
      this.steps.forEach(function (s) { self.io.observe(s); });
    }

    disconnectedCallback() { if (this.io) this.io.disconnect(); }

    activate(step) {
      if (step === this.current) return;
      this.current = step;
      this.steps.forEach(function (s) { s.classList.toggle('is-on', s === step); });

      var idx = step.dataset.img || '0';
      this.imgs.forEach(function (img) { img.classList.toggle('is-on', img.dataset.storyImg === idx); });

      if (this.dot) {
        var x = step.dataset.x;
        var y = step.dataset.y;
        if (x && y && x !== '0') {
          this.dot.style.left = x + '%';
          this.dot.style.top = y + '%';
          this.dot.classList.add('is-on');
        } else {
          this.dot.classList.remove('is-on');
        }
      }
    }
  }
  if (!customElements.get('tl-story')) customElements.define('tl-story', TlStory);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-versus"] && !Shopify.designMode) return;
  try {
    
  class TlDrawers extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-drawer]').forEach(function (drawer) {
        var btn = drawer.querySelector('.tl-drawer__btn');
        if (!btn) return;
        btn.addEventListener('click', function () {
          var open = drawer.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    }
  }
  if (!customElements.get('tl-drawers')) customElements.define('tl-drawers', TlDrawers);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-stories"] && !Shopify.designMode) return;
  try {
    
  class VideoStories extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.vstories__track');
      this.dotsEl = this.querySelector('.vstories__dots');
      if (this.track) {
        this.querySelectorAll('.vstories__arrow').forEach((btn) => {
          btn.addEventListener('click', () => {
            const dir = btn.dataset.dir === 'next' ? 1 : -1;
            this.track.scrollBy({ left: dir * this.track.clientWidth * 0.85, behavior: 'smooth' });
          });
        });
        this.track.addEventListener('scroll', () => this.syncDots(), { passive: true });
        window.addEventListener('resize', () => this.buildDots());
        this.buildDots();
      }

      // Autoplay mudo/loop, mas carrega/toca SÓ quando visível (economiza banda: home tem vários vídeos)
      this.videos = [...this.querySelectorAll('.vstory__video')];
      this.videos.forEach((v) => { v.muted = true; v.playsInline = true; });
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) { e.target.muted = true; e.target.play().catch(() => {}); }
            else { e.target.pause(); }
          });
        }, { threshold: 0.25 });
        this.videos.forEach((v) => this.io.observe(v));
      } else {
        this.videos.forEach((v) => v.play().catch(() => {}));
      }

      // Clicar no vídeo abre em tela cheia COM som (lightbox)
      this.lb = this.querySelector('.vstory-lb');
      this.lbVideo = this.querySelector('.vstory-lb__video');
      this.querySelectorAll('.vstory__media').forEach((media) => {
        media.addEventListener('click', (e) => {
          if (e.target.closest('.vstory__product')) return;
          const v = media.querySelector('.vstory__video');
          if (v) this.openLightbox(v);
        });
      });
      if (this.lb) {
        this.lb.addEventListener('click', (e) => {
          if (e.target === this.lb || e.target.closest('.vstory-lb__close')) this.closeLightbox();
        });
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.lb && !this.lb.hidden) this.closeLightbox();
        });
      }
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); }

    openLightbox(v) {
      if (!this.lb || !this.lbVideo) return;
      const source = v.querySelector('source');
      const src = v.currentSrc || (source ? source.src : '');
      if (!src) return;
      this.lbVideo.src = src;
      this.lbVideo.muted = false;
      this.lbVideo.currentTime = 0;
      this.lb.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      this.lbVideo.play().catch(() => {});
    }
    closeLightbox() {
      if (!this.lbVideo) return;
      this.lbVideo.pause();
      this.lbVideo.removeAttribute('src');
      this.lbVideo.load();
      this.lb.hidden = true;
      document.documentElement.style.overflow = '';
    }

    buildDots() {
      if (!this.track) return;
      const pages = Math.max(1, Math.ceil((this.track.scrollWidth - 4) / this.track.clientWidth));
      const single = pages <= 1;
      this.querySelectorAll('.vstories__arrow').forEach((a) => { a.style.display = single ? 'none' : ''; });
      if (!this.dotsEl) return;
      this.dotsEl.innerHTML = '';
      if (single) { this.dotsEl.style.display = 'none'; return; }
      this.dotsEl.style.display = '';
      for (let p = 0; p < pages; p++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'vstories__dot' + (p === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Page ' + (p + 1));
        dot.addEventListener('click', () => this.track.scrollTo({ left: p * this.track.clientWidth, behavior: 'smooth' }));
        this.dotsEl.appendChild(dot);
      }
    }
    syncDots() {
      if (!this.dotsEl) return;
      const dots = [...this.dotsEl.children];
      if (!dots.length) return;
      const page = Math.round(this.track.scrollLeft / this.track.clientWidth);
      dots.forEach((d, i) => d.classList.toggle('is-active', i === page));
    }
  }
  customElements.define('video-stories', VideoStories);

  } catch(e) { console.error(e); }
})();
})();
